const ZertoDocumentPreview = ({
  documents = [],
  zipSize = "6.30MB",
  className = "",
  svgHeight,
}) => {
  return (
    <div className={`relative w-full max-w-[384px] mx-auto ${className}`}>
      {/* ===== CARD BACKGROUND ===== */}
      <div className="absolute top-[60px] w-full h-[200px] md:h-[248px] rounded-xl bg-green-02 z-0" />

      {/* ===== TOP IMAGES ===== */}
      <div className="relative flex justify-center items-start h-[200px] z-10 left-9">
        {/* LEFT */}
        {documents[0]?.img && (
          <img
            src={documents[0].img}
            alt="left"
            className="absolute left-[8%] top-[20px] w-[136px] h-[193px] rotate-[-4deg] z-10 shadow-md rounded"
          />
        )}

        {/* CENTER */}
        {documents[1]?.img && (
          <img
            src={documents[1].img}
            alt="center"
            className="relative w-[136px] h-[193px] z-20 shadow-md rounded"
          />
        )}

        {/* RIGHT */}
        {documents[2]?.img && (
          <img
            src={documents[2].img}
            alt="right"
            className="absolute right-[8%] top-[20px] w-[136px] h-[193px] rotate-[5deg] z-10 shadow-md rounded"
          />
        )}
      </div>

      {/* ===== CONTENT BOX ===== */}
      <div className="absolute top-[100px] w-full px-5 z-20">
        {/* SVG BACKGROUND */}
        <div className="absolute -top-5 md:top-0 left-0 w-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="380"
            height="208"
            viewBox="0 0 380 208"
            fill="none"
            className="w-full h-[208px] md:h-auto"
          >
            <path
              d="M0 10V32.4242V198C0 203.523 4.47716 208 10 208H370C375.523 208 380 203.523 380 198V42.0152C380 36.4864 375.514 32.0068 369.985 32.0152L107.503 32.4139C103.408 32.4202 99.7225 29.9289 98.2022 26.1264L90.2701 6.2875C88.7519 2.49017 85.0744 0 80.9848 0H10C4.47715 0 0 4.47715 0 10Z"
              fill="#3C545A"
            />
          </svg>
        </div>

        {/* CONTENT */}
        <div className="relative pt-3 flex flex-col gap-3 -top-[10px] sm:-top-[18px] -left-[6px] md:top-0 md:left-0">
          <p className="text-grey-01 text-[10.25px] md:text-[12px] font-medium text-start font-inter">
            Zip · {zipSize}
          </p>

          <p className="text-grey-01 text-[10px] md:text-[12px] text-start font-inter">
            What you’ll get?
          </p>

          {documents.map((doc, i) => (
            <>
              <div key={i} className="flex items-center gap-3">
                <div className="flex w-[42px] aspect-square p-[4px_4px_0_4px] justify-center items-center rounded-[4px] bg-[#5B5D7C]">
                  <img
                    src={doc.img}
                    className="w-full h-[34px] object-cover md:h-auto rounded-sm "
                  />
                </div>
                <div className="text-start">
                  <p className="text-grey-01 font-medium text-[14px] md:text-[16px] font-google">
                    {doc.title}
                  </p>
                  <p className="text-grey-03 text-[10px] md:text-[12px] font-inter">
                    {doc.pages}
                  </p>
                </div>
              </div>
              {i < documents.length - 1 && (
                <div className="w-full h-[1px] border-white/10 border-dashed border-t" />
              )}
            </>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ZertoDocumentPreview;
